module.exports = {
  HOME: "/",
  CONTACT_US: "/contact-us",
  NEWS: "/news",
  DISCOVER: "/discover",
};
